/* =========================================================
   UI primitives and decorative components — Parcours d'Artistes
   ========================================================= */

/* ---------- Icons (inline SVG) ---------- */
export const Icon = ({ name, size = 18, stroke = 1.6, ...p }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...p
  };

  switch (name) {
    case "search": return <svg {...common}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>;
    case "map": return <svg {...common}><path d="M9 3 3 5v16l6-2 6 2 6-2V3l-6 2-6-2Z" /><path d="M9 3v16M15 5v16" /></svg>;
    case "pin": return <svg {...common}><path d="M12 22s-7-7.5-7-13a7 7 0 1 1 14 0c0 5.5-7 13-7 13Z" /><circle cx="12" cy="9" r="2.5" /></svg>;
    case "calendar": return <svg {...common}><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /></svg>;
    case "users": return <svg {...common}><circle cx="9" cy="8" r="3.5" /><path d="M2 21c0-3.5 3-6 7-6s7 2.5 7 6" /><circle cx="17" cy="9" r="2.5" /><path d="M22 20c0-2.5-2-4.5-5-4.5" /></svg>;
    case "house": return <svg {...common}><path d="M3 11 12 3l9 8" /><path d="M5 10v10h14V10" /></svg>;
    case "heart": return <svg {...common}><path d="M12 21s-7-4.7-9.5-9.4C.7 7.9 3.2 4 7 4c2 0 3.5 1 5 3 1.5-2 3-3 5-3 3.8 0 6.3 3.9 4.5 7.6C19 16.3 12 21 12 21Z" /></svg>;
    case "heart-fill": return <svg {...common} fill="currentColor"><path d="M12 21s-7-4.7-9.5-9.4C.7 7.9 3.2 4 7 4c2 0 3.5 1 5 3 1.5-2 3-3 5-3 3.8 0 6.3 3.9 4.5 7.6C19 16.3 12 21 12 21Z" /></svg>;
    case "share": return <svg {...common}><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="6" r="2.5" /><circle cx="18" cy="18" r="2.5" /><path d="m8 10.5 8-3.5M8 13.5l8 3.5" /></svg>;
    case "arrow-right": return <svg {...common}><path d="M5 12h14M14 6l6 6-6 6" /></svg>;
    case "arrow-up-right": return <svg {...common}><path d="M7 17 17 7M9 7h8v8" /></svg>;
    case "arrow-left": return <svg {...common}><path d="M19 12H5M10 6l-6 6 6 6" /></svg>;
    case "plus": return <svg {...common}><path d="M12 5v14M5 12h14" /></svg>;
    case "filter": return <svg {...common}><path d="M3 5h18M6 12h12M10 19h4" /></svg>;
    case "grid": return <svg {...common}><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /></svg>;
    case "list": return <svg {...common}><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" /></svg>;
    case "close": return <svg {...common}><path d="M6 6 18 18M18 6 6 18" /></svg>;
    case "menu": return <svg {...common}><path d="M4 6h16M4 12h16M4 18h16" /></svg>;
    case "compass": return <svg {...common}><circle cx="12" cy="12" r="9" /><path d="m15 9-4 2-2 4 4-2 2-4Z" /></svg>;
    case "check": return <svg {...common}><path d="m5 12 5 5 9-12" /></svg>;
    case "dot": return <svg {...common}><circle cx="12" cy="12" r="3" fill="currentColor" /></svg>;
    case "external": return <svg {...common}><path d="M14 4h6v6M20 4 10 14M19 14v6H4V5h6" /></svg>;
    case "settings": return <svg {...common}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.6 1.7 1.7 0 0 0-1.8.3l-.1.1A2 2 0 1 1 4.3 16.7l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9c.3.6.9 1 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" /></svg>;
    case "bell": return <svg {...common}><path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10 21a2 2 0 0 0 4 0" /></svg>;
    case "edit": return <svg {...common}><path d="M11 4H4v16h16v-7" /><path d="M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5Z" /></svg>;
    case "trash": return <svg {...common}><path d="M3 6h18M8 6V4h8v2m-7 0v14h6V6" /></svg>;
    case "eye": return <svg {...common}><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z" /><circle cx="12" cy="12" r="3" /></svg>;
    case "globe": return <svg {...common}><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" /></svg>;
    case "feather": return <svg {...common}><path d="M20.2 3.8a6.5 6.5 0 0 1 0 9.2L13 20l-7 1 1-7 6.9-6.9a6.5 6.5 0 0 1 6.3-3.3Z" /><path d="M16 8 2 22M17.5 15H9" /></svg>;
    case "sparkle": return <svg {...common}><path d="M12 3v6M12 15v6M3 12h6M15 12h6M5.6 5.6l4.2 4.2M14.2 14.2l4.2 4.2M5.6 18.4l4.2-4.2M14.2 9.8l4.2-4.2" /></svg>;
    case "logout": return <svg {...common}><path d="M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4M16 17l5-5-5-5M21 12H9" /></svg>;
    case "chart": return <svg {...common}><path d="M3 3v18h18" /><path d="M7 14l4-4 4 3 5-6" /></svg>;
    case "play": return <svg {...common}><path d="M6 4v16l14-8L6 4Z" /></svg>;
    case "lock": return <svg {...common}><rect x="4" y="11" width="16" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></svg>;
    case "mail": return <svg {...common}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>;
    default: return null;
  }
};

/* ---------- Brand mark ---------- */
export const Brand = ({ small }) =>
  <a href="/" className="row gap-3" style={{ textDecoration: "none" }}>
    <img
      src="/assets/logo-parcours-artistes.png"
      alt="parcours d'artistes — l'art près de chez vous"
      style={{
        height: small ? 36 : 51,
        width: "auto",
        display: "block"
      }}
    />
  </a>;

export const BrandMark = ({ size = 36 }) =>
  <img
    src="/assets/logo-parcours-artistes.png"
    alt=""
    style={{ height: size, width: "auto", display: "block" }}
  />;

/* ---------- Festival decorative elements ---------- */
export const Tape = ({ color = "yellow", width = 140, height = 28, rotate = -4, style }) =>
  <div
    className={"tape tape-" + color}
    style={{ width, height, transform: `rotate(${rotate}deg)`, ...style }}
  />;

export const Stamp = ({ children, color, style }) =>
  <span
    className="stamp"
    style={{
      background: color || "var(--ink)",
      color: color === "var(--yellow)" || color === "var(--green)" ? "var(--ink)" : "var(--paper)",
      ...style
    }}
  >
    {children}
  </span>;

export const Sticky = ({ color = "purple", rotate = 0, children, style }) =>
  <div
    className={"sticky sticky-" + color}
    style={{ transform: rotate ? `rotate(${rotate}deg)` : null, ...style }}
  >
    {children}
  </div>;

export const Marker = ({ color = "yellow", rotate = -1.5, children, style }) =>
  <span style={{ position: "relative", display: "inline-block", padding: "4px 10px", ...style }}>
    <span
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 0,
        background: `var(--${color})`,
        clipPath: "polygon(2% 6%, 98% 0%, 100% 88%, 96% 100%, 4% 96%, 0% 14%)",
        transform: `rotate(${rotate}deg)`
      }}
    />
    <span style={{ position: "relative", zIndex: 1 }}>{children}</span>
  </span>;

export const ScribbleCircle = ({ color = "var(--ink)", style }) =>
  <svg viewBox="0 0 200 80" style={style} aria-hidden="true">
    <path
      d="M30 40 C30 18 70 8 110 12 C150 16 188 26 188 44 C188 62 144 72 100 70 C56 68 28 60 26 42 C24 30 50 22 90 20"
      fill="none"
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
      opacity="0.9"
    />
  </svg>;

export const AsteriskHand = ({ color = "var(--ink)", size = 40, style }) =>
  <svg viewBox="0 0 40 40" width={size} height={size} style={style} aria-hidden="true">
    <g stroke={color} strokeWidth="2.5" strokeLinecap="round" fill="none">
      <path d="M20 5 L20 35" />
      <path d="M5 20 L35 20" />
      <path d="M9 9 L31 31" />
      <path d="M31 9 L9 31" />
    </g>
  </svg>;

/* ---------- Painted decorative SVG strokes ---------- */
export const BrushBlob = ({ color = "var(--terracotta)", style }) =>
  <svg viewBox="0 0 200 200" style={style} aria-hidden="true">
    <path
      d="M30,90 C20,40 80,10 120,30 C170,55 200,80 180,130 C160,180 110,200 60,180 C20,165 35,140 30,90 Z"
      fill={color}
      opacity="0.92"
    />
  </svg>;

export const BrushStroke = ({ color = "var(--terracotta)", style, d, className }) =>
  <svg viewBox="0 0 400 80" preserveAspectRatio="none" className={className} style={style} aria-hidden="true">
    <path d={d || "M5 40 L380 32 L390 50 L8 56 Z"} fill={color} opacity="0.92" />
  </svg>;

/* ---------- Hand-drawn doodles ---------- */
export const DoodleArrow = ({ style, color = "currentColor" }) =>
  <svg viewBox="0 0 80 100" style={style} aria-hidden="true">
    <path
      d="M58 8 Q42 14 30 28 Q18 44 20 62 Q22 78 36 90"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M28 82 L36 90 L48 84"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>;

export const DoodleUnderline = ({ style, color = "var(--ochre)", thick = 8 }) =>
  <svg viewBox="0 0 300 18" preserveAspectRatio="none" style={style} aria-hidden="true">
    <path
      d="M4 12 Q60 4 140 8 Q220 12 296 6"
      fill="none"
      stroke={color}
      strokeWidth={thick}
      strokeLinecap="round"
      opacity="0.9"
    />
  </svg>;

export const DoodleCircle = ({ style, color = "currentColor" }) =>
  <svg viewBox="0 0 120 80" style={style} aria-hidden="true">
    <path
      d="M60 6 C90 6 112 22 112 40 C112 60 86 74 58 74 C28 74 8 58 8 38 C8 20 32 6 60 6 Z"
      fill="none"
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>;

export const DoodleScribble = ({ style, color = "var(--slate)" }) =>
  <svg viewBox="0 0 80 80" style={style} aria-hidden="true">
    <path
      d="M10 12 Q22 4 32 14 Q42 24 50 14 Q58 4 70 12 Q56 24 62 36 Q68 48 56 56 Q44 64 50 70 Q34 74 22 64 Q10 54 18 44 Q26 34 14 28 Q4 22 10 12 Z"
      fill="none"
      stroke={color}
      strokeWidth="2"
      opacity="0.7"
    />
  </svg>;

export const DoodleStar = ({ style, color = "var(--terracotta)" }) =>
  <svg viewBox="0 0 60 60" style={style} aria-hidden="true">
    <path d="M30 8 L34 26 L52 30 L34 34 L30 52 L26 34 L8 30 L26 26 Z" fill={color} opacity="0.9" />
  </svg>;

export const DoodleDots = ({ style, color = "var(--ink)", count = 6 }) => {
  const dots = [];
  for (let i = 0; i < count; i++) {
    const cx = 10 + Math.cos(i * 1.3) * 30 + 20;
    const cy = 30 + Math.sin(i * 1.7) * 22;
    const r = 2 + (i % 3);
    dots.push(<circle key={i} cx={cx} cy={cy} r={r} fill={color} />);
  }
  return <svg viewBox="0 0 80 60" style={style} aria-hidden="true">{dots}</svg>;
};

/* ---------- Stat bubble ---------- */
export const Stat = ({ n, label, color }) =>
  <div className="stat-bubble">
    <div className="n" style={color ? { color } : null}>{n}</div>
    <div className="lbl">{label}</div>
  </div>;

/* ---------- Section title ---------- */
export const SectionTitle = ({ eyebrow, title, italic, sub, action, underline = true }) =>
  <div className="row between wrap" style={{ alignItems: "flex-end", marginBottom: 44, gap: 24 }}>
    <div className="stack gap-4" style={{ maxWidth: 760 }}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2 className="section-title-h2" style={{ textWrap: "balance" }}>
        <span className={underline ? "section-title-underlined" : ""}>{title}</span>
        {italic && (
          <>
            {" "}
            <span className="script" style={{ textTransform: "none", fontSize: "0.72em", marginLeft: 12 }}>
              {italic}
            </span>
          </>
        )}
      </h2>
      {sub && <p className="muted" style={{ margin: 0, fontSize: 16, maxWidth: 620, lineHeight: 1.5 }}>{sub}</p>}
    </div>
    {action}
  </div>;

/* ---------- Tiny chip filter group ---------- */
export const ChipGroup = ({ items, value, onChange }) =>
  <div className="row gap-2 wrap">
    {items.map((it) => (
      <button
        key={it.value || it}
        className={"chip " + (value === (it.value || it) ? "chip-active" : "")}
        onClick={() => onChange(it.value || it)}
      >
        {it.label || it}
      </button>
    ))}
  </div>;

/* ---------- Painted ribbon banner ---------- */
export const PaintedRibbon = ({ children, color = "var(--terracotta)" }) =>
  <span style={{ position: "relative", display: "inline-block", padding: "0 14px" }}>
    <svg
      viewBox="0 0 300 60"
      preserveAspectRatio="none"
      style={{ position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: -1 }}
    >
      <path d="M5 38 Q70 12 150 32 T295 30 L296 56 L4 56 Z" fill={color} opacity="0.9" />
    </svg>
    <span style={{ color: "var(--paper-warm)", fontStyle: "italic" }}>{children}</span>
  </span>;
